import axios  from 'axios'
import recordDate from '@/mixins/shop.json'
export const method = {
    data () {
        return {
            detailId:'',
            pagination: {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            },
        }
    },
    watch: {
        pageList: {
            handler(newValue, oldValue) {
                if(!this.isEmpty(newValue.result)){
                    this.dataSource = newValue.result.records
                    this.pagination.current = newValue.result.current
                    this.pagination.total =newValue.result.total
                    this.pagination.pageSize = newValue.result.size
                    this.pages = this.pageList.result.pages
                    this.$store.state.isLoding = false
                }
            },
            deep: true
        },
    },
    methods:{
        getmessageobj(url,data,params){
            this.$store.state.isLoding = true
            this.getPageList(url,
                data,{
                    'Content-Type':'application/json',
                    companyStoreId:this.$store.state.shopId
                },params)
            // this.dataSource = recordDate.result.record
        },
         /**
            * @description: 分页
            */
        onShowSizeChange(current, pageSize){
            this.pagination.current = current
            this.pagination.pageSize = pageSize
            this.getmessagedata()
        },
        handleTableChange(current){
            this.pagination.current = current
            this.getmessagedata()
        },
    }   
}